import { useState, useEffect, useMemo } from 'react'
import { theme } from '../Global/Theme'

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  }))

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // Ensure we have accurate initial values
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // Calculate breakpoints
  const {
    isMobile,
    isTablet,
    isXSmall,
    isSmall,
    isMedium,
    isLarge,
    isExtraLarge,
  } = useMemo(() => {
    const xSmallBreakpoint = parseInt(theme.breakPoints.xSmall, 10)
    const mobileBreakpoint = parseInt(theme.breakPoints.mobile, 10)
    const smallBreakpoint = parseInt(theme.breakPoints.small, 10)
    const tabletBreakpoint = parseInt(theme.breakPoints.tablet, 10)
    const mediumBreakpoint = parseInt(theme.breakPoints.medium, 10)
    const largeBreakpoint = parseInt(theme.breakPoints.large, 10)

    return {
      isMobile: windowSize.width <= mobileBreakpoint,
      isTablet: windowSize.width <= tabletBreakpoint,
      isXSmall: windowSize.width <= xSmallBreakpoint,
      isSmall: windowSize.width <= smallBreakpoint,
      isMedium: windowSize.width <= mediumBreakpoint,
      isLarge: windowSize.width > mediumBreakpoint,
      isExtraLarge: windowSize.width >= largeBreakpoint,
    }
  }, [windowSize.width])

  return {
    windowSize,
    isMobile,
    isTablet,
    isXSmall,
    isSmall,
    isMedium,
    isLarge,
    isExtraLarge,
  }
}

export default useWindowSize
